import * as React from 'react';
import * as FontAwesome from 'react-fontawesome';
import { connect, Dispatch } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
// import * as shortId from 'shortid';
import TileWall from '../../components/tileWall/tileWall';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { newsActionCreators } from '../../data/news/newsActions';
import { ApiNewsState /* ApiNewsObject */ } from '../../data/news/newsModels';
import './news.css';
// tslint:disable-next-line:no-var-requires
const moment = require('moment');
// tslint:disable-next-line:no-var-requires
require('moment/locale/sv');
// tslint:disable-next-line:no-var-requires
const news = require('../../resources/news.png');

interface NewsState {
    news: ApiNewsState;
    header: HeaderState;
}

interface NewsActions {
    newsActions: typeof newsActionCreators;
    headerActions: typeof headerActionCreators;
}

type NewsProps = NewsState & // ... state we've requested from the Redux store
    NewsActions & // ... plus action creators we've requested
    RouteComponentProps<{}>; // ... plus incoming routing parameters

class News extends React.Component<NewsProps, {}> {
    constructor(props: NewsProps) {
        super(props);
        this.renderNews = this.renderNews.bind(this);
    }

    componentWillMount() {
        this.props.headerActions.setBottomHeader('My Quick Solutions Online');
    }

    componentDidUpdate(prevProps: NewsProps) {
        if (prevProps.news.thenews !== this.props.news.thenews) {
            this.forceUpdate();
        }
    }

    renderNews(props: NewsProps) {
        const arr = Array<any>();
        for (const x of props.news.thenews) {
            const tileHead = (
                <div>
                    <div className="float-left">
                        <h3>{x.topic}</h3>
                    </div>
                </div>
            );
            const tileBody = (
                <div>
                    <div className="topBorder" />
                    <div>{moment(x.publishDate, 'M/D/YYYY').format('M/D/YYYY')}</div>
                    <p>{x.description}</p>
                    <a target="_blank" href={x.url}>
                        Link to article
                    </a>
                </div>
            );
            arr.push({
                tileHead: tileHead,
                tileBody: tileBody
            });
        }
        return arr;
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="componentHeader">
                    <div className="item tile">
                        <div className="tileHead">
                            <div className="float-left">
                                <h4>{'News'}</h4>
                            </div>
                            <div className="tileImage float-right">{<img src={news} />}</div>
                        </div>
                        <div className="tileBody">
                            <div className="topBorder" />
                        </div>
                    </div>
                </div>
                {this.props.news.thenews.length > 0 ? (
                    <TileWall tileObjects={this.renderNews(this.props)} />
                ) : (
                    <div className="centerThis">
                        <FontAwesome className="progressicon" name="spinner" size="3x" spin={true} />
                    </div>
                )}
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): NewsState {
    return {
        news: state.news,
        header: state.header
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): NewsActions {
    return {
        newsActions: bindActionCreators(newsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(News)
);



// WEBPACK FOOTER //
// ./src/containers/news/news.tsx